<template>
  <div class="" style="padding: 0; width: 100%">
    <div
      class=""
      id="fertilizationAnalysisLeftTop"
      @mouseenter="clearDispatchTimer"
      @mouseleave="setDispatchTimer"
    ></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-gl";
export default {
  data() {
    return {
      interVal: "",
      myChart: null,
      app: {
        currentIndex: -1,
      },
      dispatchTimer: null,
      dataLen: null,
    };
  },
  mounted() {
    // this.requestData(500)
    this.init();
    this.getTimeDate(5);
  },
  methods: {
    requestData(number, area, tulongNum, beforeMoney, afterMoney) {
      this.$request(
        "center/newService1/farmLines?num=" +
          number +
          "&area=" +
          area +
          "&tulongNum=" +
          tulongNum +
          "&beforeMoney=" +
          beforeMoney +
          "&afterMoney=" +
          afterMoney
      ).then((res) => {
        if (this.myChart) {
          clearInterval(this.dispatchTimer);
          this.myChart.clear();
        }
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].type == 1) {
            this.init(res.data[i].list);
          }
        }
      });
    },
    init(pageData, type) {
      let that = this;

      that.myChart = echarts.init(
        document.getElementById("fertilizationAnalysisLeftTop")
      );

      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        that.myChart.resize();
      });

      // echart配置
      var option = {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            let result = params[0].axisValue + "<br/>";
            params.forEach(function (item) {
              // 为每个系列添加不同的单位
              let unit = "";
              if (item.seriesName === "氮") {
                unit = "ppm";
              } else if (item.seriesName === "磷") {
                unit = "ppm";
              } else if (item.seriesName === "钾") {
                unit = "ppm";
              } else if (item.seriesName === "EC") {
                unit = "ms/cm";
              } else if (item.seriesName === "pH") {
                unit = "";
              } else if (item.seriesName === "温度") {
                unit = "℃";
              }
              result += `${item.marker} ${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          },
        },
        legend: {
          top: "5%",
          right: "27%",
          itemGap: 20,
          textStyle: {
            color: "#C5D6E6",
            // fontWeight: 'bold'
          },
        },
        grid: {
          left: "6%",
          right: "6%",
          bottom: "5%",
          // top: '10%',
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [
              that.getTimeDate(6),
              that.getTimeDate(5),
              that.getTimeDate(4),
              that.getTimeDate(3),
              that.getTimeDate(2),
              that.getTimeDate(1),
              that.getTimeDate(0),
            ],
            axisLabel: {
              textStyle: {
                color: "#C5D6E6",
              },
            },
            boundaryGap: false, // 设置为false，X轴将贴边显示
            axisLine: {
              lineStyle: {
                color: "#D9E7FF",
              },
            },
            // axisTick: {
            //   show: false // 取消 x 轴刻度
            // }
          },
        ],
        yAxis: [
          {
            type: "value",
            splitNumber: 4,
            splitLine: {
              lineStyle: {
                color: "rgba(217, 231, 255, 0.3)",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#C5D6E6",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#333",
              },
            },
            nameTextStyle: {
              color: "#999",
            },
            splitArea: {
              show: false,
            },
          },
        ],
        // https://www.yuque.com/sxd_panda/antv/x6
        series: [
          {
            name: "氮",
            type: "line",
            data: [180, 190, 200, 210, 220, 215, 205],
            lineStyle: {
              normal: {
                width: 2,
                color: "#1a7ca3",
                shadowColor: "#1a7ca3",
                shadowBlur: 10,
                shadowOffsetY: 20,
              },
            },
            areaStyle: {
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#1a7ca3",
                    },
                    {
                      offset: 1,
                      color: "rgba(15, 222, 255, 0)",
                    },
                  ],
                  false
                ),
              },
            },
            // 图例样式
            itemStyle: {
              color: "rgba(15, 222, 255, 1)",
            },
            smooth: true,
            symbol: "none", // 设置拐点不显示
          },
          {
            name: "磷",
            type: "line",
            data: [35, 40, 38, 42, 45, 43, 40],
            lineStyle: {
              normal: {
                width: 2,
                color: "#c5c536",
              },
            },
            areaStyle: {
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#c5c536",
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 144, 255, 0)",
                    },
                  ],
                  false
                ),
              },
            },
            // 图例样式
            itemStyle: {
              color: "#c5c536",
            },
            smooth: true,
            symbol: "none", // 设置拐点不显示
          },
          {
            name: "钾",
            type: "line",
            data: [180, 175, 190, 200, 210, 205, 200],
            lineStyle: {
              normal: {
                width: 2,
                color: "#33c45f",
              },
            },
            areaStyle: {
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#33c45f",
                    },
                    {
                      offset: 1,
                      color: "rgba(255, 208, 59, 0)",
                    },
                  ],
                  false
                ),
              },
            },
            // 图例样式
            itemStyle: {
              color: "#33c45f",
            },
            smooth: true,
            symbol: "none", // 设置拐点不显示
          },
        ],
      };

      that.dataLen = option.series[0].data.length;
      that.dispatchActions();

      that.myChart.setOption(option);
      //   this.interVal = setInterval(function () {
      //     that.myChart.clear();
      //     that.myChart.setOption(option);
      //   }, 240000);
      // 20000
    },
    dispatchActions() {
      let that = this;
      that.dispatchTimer = setInterval(function () {
        // 取消之前高亮的图形
        that.myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
        that.app.currentIndex = (that.app.currentIndex + 1) % that.dataLen;
        //console.log(app.currentIndex);
        // 高亮当前图形
        that.myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
        // 显示 tooltip
        that.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
      }, 3000);
    },
    clearDispatchTimer() {
      clearInterval(this.dispatchTimer);
    },
    setDispatchTimer() {
      this.dispatchActions();
    },
    changeEcharts(e) {
      let that = this;
      let data = [];
      let color = [];
      let title = "";

      switch (e) {
        case "氮":
          title = "氮";
          color = "rgba(15, 222, 255, 1)";
          data = [180, 190, 200, 210, 220, 215, 205];
          break;
        case "磷":
          title = "磷";
          color = "rgba(0, 144, 255, 1)";
          data = [35, 40, 38, 42, 45, 43, 40];
          break;
        case "钾":
          title = "钾";
          color = "rgba(255, 208, 59, 1)";
          data = [180, 175, 190, 200, 210, 205, 200];
          break;
        case "EC":
          title = "EC";
          color = "rgba(15, 222, 255, 1)";
          data = [1.2, 1.5, 1.3, 1.6, 1.8, 1.7, 1.4];
          break;
        case "pH":
          title = "pH";
          color = "rgba(15, 222, 255, 1)";
          data = [7.8, 7.9, 7.7, 8.0, 7.9, 7.8, 7.7];
          break;
        case "温度":
          title = "温度";
          color = "rgba(15, 222, 255, 1)";
          data = [22, 24, 23, 25, 26, 24, 23];
          break;
        default:
          break;
      }
      this.myChart.clear();
      if (e == "默认") {
        this.init();
        return;
      }
      this.myChart.setOption({
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            let result = params[0].axisValue + "<br/>";
            params.forEach(function (item) {
              // 为每个系列添加不同的单位
              let unit = "";
              if (item.seriesName === "氮") {
                unit = "ppm";
              } else if (item.seriesName === "磷") {
                unit = "ppm";
              } else if (item.seriesName === "钾") {
                unit = "ppm";
              } else if (item.seriesName === "EC") {
                unit = "ms/cm";
              } else if (item.seriesName === "pH") {
                unit = "";
              } else if (item.seriesName === "温度") {
                unit = "℃";
              }
              result += `${item.marker} ${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          },
        },
        legend: {
          top: "5%",
          right: "27%",
          itemGap: 20,
          textStyle: {
            color: "#C5D6E6",
            // fontWeight: 'bold'
          },
        },
        grid: {
          left: "1%",
          right: "7%",
          bottom: "5%",
          // top: '10%',
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [
              that.getTimeDate(6),
              that.getTimeDate(5),
              that.getTimeDate(4),
              that.getTimeDate(3),
              that.getTimeDate(2),
              that.getTimeDate(1),
              that.getTimeDate(0),
            ],
            axisLabel: {
              textStyle: {
                color: "#C5D6E6",
              },
            },
            boundaryGap: false, // 设置为false，X轴将贴边显示
            axisLine: {
              lineStyle: {
                color: "#D9E7FF",
              },
            },
            // axisTick: {
            //   show: false // 取消 x 轴刻度
            // }
          },
        ],
        yAxis: [
          {
            type: "value",
            splitNumber: 4,
            splitLine: {
              lineStyle: {
                color: "rgba(217, 231, 255, 0.3)",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#C5D6E6",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#333",
              },
            },
            nameTextStyle: {
              color: "#999",
            },
            splitArea: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: title,
            type: "line",
            data: data,
            lineStyle: {
              normal: {
                width: 2,
                color: color,
                shadowColor: "rgba(72,216,191, 0.3)",
                shadowBlur: 10,
                shadowOffsetY: 20,
              },
            },
            areaStyle: {
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#0FDEFF",
                    },
                    {
                      offset: 1,
                      color: color,
                    },
                  ],
                  false
                ),
              },
            },
            // 图例样式
            itemStyle: {
              color: color,
            },
            smooth: true,
            symbol: "none", // 设置拐点不显示
          },
        ],
      });
    },
    getTimeDate(e) {
      const today = new Date();
      // 获取昨日日期
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - e);
      return this.utils.changeTimeNoHms(yesterday);
    },
  },
  destroyed() {
    clearInterval(this.interVal);
  },
};
</script>

<style>
#fertilizationAnalysisLeftTop {
  height: 370px;
}
</style>